import { Space, Text as MantineText } from '@mantine/core';
import { useLingui } from '@lingui/react';
import { FC, Fragment } from 'react';
import BookitupTable from '../../../Atoms/BookitupTable';
import { DocumentDto } from '../../../Service/DocumentT';
import DocumentListItem from './DocumentListItem';
import './DocumentPaneTable.css';

interface DocumentPaneTableProps {
  documentsByType: Record<string, DocumentDto[]>;
  reload: () => void;
}

const DocumentPaneTable: FC<DocumentPaneTableProps> = ({ documentsByType, reload }) => {
  const { i18n } = useLingui();

  return (
    <div className="document-pane-table">
      <BookitupTable>
        <thead>
          <tr>
            <th className="document-pane__column--status">Status</th>
            <th className="document-pane__column--number">Nummer</th>
            <th className="document-pane__column--name">Name</th>
            <th className="document-pane__column--date">Datum</th>
            <th className="document-pane__column--sum">Betrag</th>
            <th className="document-pane__column--due-date">Frist</th>
            <th className="document-pane__column--portal">Portal</th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(documentsByType).map(([documentType, documents]) => (
            <Fragment key={documentType}>
              <tr className="notHover" style={{ backgroundColor: 'transparent' }}>
                <td colSpan={8}>
                  <MantineText weight="bolder">
                    <b> {i18n._(`document.${documentType.toLowerCase()}`)}</b>
                  </MantineText>
                </td>
              </tr>
              {documents.map((document) => (
                <DocumentListItem
                  key={document.id}
                  bookitupDocument={document}
                  reload={reload}
                  showNumber
                  showName
                  showDatum
                  showSum
                  showDueDate
                  showPortal
                  narrowPortalStatus={false}
                />
              ))}
              <tr aria-hidden="true" className="notHover" style={{ backgroundColor: 'transparent' }}>
                <td colSpan={8}>
                  <Space h="md" />
                </td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </BookitupTable>
    </div>
  );
};

export default DocumentPaneTable;
